import { Controller } from "@hotwired/stimulus"

// Handles Bootstrap 5 collapse expansion via URL hash
// Replaces: app/assets/javascripts/link_to_attachment.js
//
// Features:
// - Opens collapse if URL hash matches element ID
// - Scrolls to element after collapse is shown
// - Uses Bootstrap 5 vanilla JS API (no jQuery)
//
// Usage:
//   <div id="attachment-123" class="collapse"
//        data-controller="hash-collapse"
//        data-hash-collapse-offset-value="100">
//     Content...
//   </div>
export default class extends Controller {
  static values = {
    offset: { type: Number, default: 100 }  // Scroll offset from top
  }

  connect() {
    const hash = window.location.hash

    // Check if this collapse matches the URL hash
    if (hash && `#${this.element.id}` === hash) {
      this.showAndScroll()
    }
  }

  showAndScroll() {
    // Show the collapse using Bootstrap 5 vanilla JS API
    const collapse = new bootstrap.Collapse(this.element, { show: true })

    this.element.addEventListener('shown.bs.collapse', () => {
      this.scrollToElement()
    }, { once: true })
  }

  scrollToElement() {
    const elementTop = this.element.getBoundingClientRect().top + window.scrollY
    const scrollPosition = elementTop - this.offsetValue

    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    })
  }
}
